import { Component, effect, inject, signal } from '@angular/core'
import { Router, RouterOutlet } from '@angular/router'
import { AuthService } from '../../infrastructure/auth/auth.service'

/** Protegemos rutas privadas y damos salida si la carga de sesion tarda demasiado. */
@Component({
  selector: 'app-protegido',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './protegido.html',
})
export class ProtegidoComponent {
  private readonly auth = inject(AuthService)
  private readonly router = inject(Router)

  readonly cargando = this.auth.cargando
  readonly perfil = this.auth.perfil
  readonly tardando = signal(false)

  private temporizador?: ReturnType<typeof setTimeout>

  constructor() {
    effect(() => {
      if (this.cargando()) {
        this.temporizador ??= setTimeout(() => this.tardando.set(true), 8000)
      } else {
        if (this.temporizador) clearTimeout(this.temporizador)
        this.temporizador = undefined
        this.tardando.set(false)
      }
    })

    effect(() => {
      if (this.cargando() || this.perfil()) return
      // Dos módulos, dos logins propios (2026-10-12) — sin sesión, cada uno
      // manda a su propia pantalla de entrada, no a un login único.
      const destino = this.router.url.startsWith('/calidad') ? '/calidad/login' : '/login'
      void this.router.navigateByUrl(destino, { replaceUrl: true })
    })
  }

  recargar(): void {
    window.location.reload()
  }
}
